import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const ArrowLeftSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M6.273 11.27 3.005 8.004l3.268-3.269M3.026 8.003h10"
    />
  </IconV2>
);

export default ArrowLeftSmallIcon;
